import React from 'react';
import ReactDOM from 'react-dom';
import {
    BrowserWarning,
    isBrowserSupported,
} from '@mgc/map-client-shared/lib/BrowserTools';
import bootstrapApp from './bootstrap';
import MapApp from './MapApp';
import './main.scss';

bootstrapApp();

// Set div to build app in
const appContainer = document.getElementById('map-app');
let content = <MapApp />;

if (!isBrowserSupported()) {
    content = (
        <div>
            <BrowserWarning />
            <MapApp />
        </div>
    );
}

ReactDOM.render(content, appContainer);



// WEBPACK FOOTER //
// ./app/index.jsx